import { FC } from 'react';
import { Box, styled, Tooltip } from '@mui/material';
import { overviewPage } from 'config/constants/assets';

const OverviewOptionsBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '32px',
  width: '100%',
  padding: '16px 16px',
  background: '#2A3139',
  borderRadius: '20px',
  boxShadow:
    '0px 2.1574831008911133px 29.22142219543457px 0px rgba(0, 0, 0, 0.05), 0px 3.806384325027466px 39.8596076965332px 0px rgba(0, 0, 0, 0.07), 0px 5.703558921813965px 44.46048355102539px 0px rgba(0, 0, 0, 0.08), 0px 10.160801887512207px 47.2956428527832px 0px rgba(0, 0, 0, 0.09), 0px 25.993473052978516px 52.371063232421875px 0px rgba(0, 0, 0, 0.10), 0px 100px 77px 0px rgba(0, 0, 0, 0.13)',
}));

const OverviewItem = styled('img')(() => ({
  cursor: 'pointer',
  height: '35px',
  width: '35px'
}));

interface Props {
  options: any[];
  activeOverviewOption: any;
  selectOverviewOption: (earnOption: any) => void;
}

function getIconSrc(key: string) {
  if( key === "tokens" )
    return overviewPage.tokens;
  if( key === "protocols" )
    return overviewPage.protocols;
  return overviewPage.liquidity ;
}

const OverviewOptions: FC<Props> = ({ options, activeOverviewOption, selectOverviewOption }) => (

  <OverviewOptionsBox>
    {options.map((earnOption: any) => (
        <Tooltip title={earnOption.label}>
            <OverviewItem
                alt="earn option"
                key={earnOption.value}
                onClick={() => selectOverviewOption(earnOption)}
                src={getIconSrc(earnOption.value)}
                sx={{ opacity: activeOverviewOption.value === earnOption.value ? '100%' : '50%' }}
            />
        </Tooltip>
    ))}
  </OverviewOptionsBox>
);

export { OverviewOptions };
